// import Cookie from '@/services/cookie'
const TOKEN_AUTH = 'services_auth'
const EXPIRATION_TIME = 1440 // 24 hours

function setToken(data: string, key: string) {
    const timeMilliseconds = EXPIRATION_TIME * 60 * 1000
    const expires = new Date().getTime() + timeMilliseconds
    const payload = {
        data,
        expires
    }
    localStorage.setItem(key, JSON.stringify(payload));
}

function getToken(key: string) {
    const now = new Date().getTime()
    const result = localStorage.getItem(key) ?? null
    if (!result) return null
    const payload = JSON.parse(result)
    if (!payload?.expires || payload.expires < now) {
        localStorage.removeItem(key)
        return null
    }
    return payload.data

}
export function getUser(): string | null {
    return getToken(TOKEN_AUTH)
}

export function addUser(value: string) : string {
    setToken(value, TOKEN_AUTH)
    return getToken(TOKEN_AUTH)
}
